import FontHeading4 from '../../../../../../../components/fonts/font-heading4/font-heading4';
import { FONT_COLOR, FONT_VARIANT } from '../../../../../../../components/fonts/font-props';

import { ItemEligibilityDto, PolicyEvaluation } from '../../order-eligibility-display.service';

import PolicyRuleCard from './policy-rule-card';

interface PolicyRulesAnalysisProps {
    filteredPolicies: PolicyEvaluation[];
    filteredItems: ItemEligibilityDto[];
    policyFilter: string;
}

const PolicyRulesAnalysis: React.FC<PolicyRulesAnalysisProps> = ({ 
    filteredPolicies, 
    filteredItems, 
    policyFilter 
}) => {
    // Filter policies based on policy filter
    let policiesToShow = filteredPolicies;
    if (policyFilter) {
        policiesToShow = filteredPolicies.filter(policy => 
            policy.policy_name.toLowerCase().includes(policyFilter.toLowerCase())
        );
    }

    return (
        <div className="policy-rules-section">
            <FontHeading4 color={FONT_COLOR.PRIMARY1} variant={[FONT_VARIANT.BOLD]}>
                Policy Rules Analysis
            </FontHeading4>
            <div className="policy-rules-list">
                {policiesToShow.map((policy) => (
                    <PolicyRuleCard 
                        key={policy.policy_id} 
                        policy={policy} 
                        items={filteredItems} 
                    />
                ))}
            </div>
        </div>
    );
};

export default PolicyRulesAnalysis;
